import {Component, AfterViewInit, Inject, OnInit, AfterContentInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FS3ValidationResult } from '../../objects/validationResult';
import { ApiService } from '../../api.service';
import { File } from '../../objects/file';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import { getDownloadZipName } from '../../utils/parseUtils';

@Component({
  selector: 'app-zip-dialog',
  templateUrl: './zip-dialog.component.html',
  providers: [ApiService]
})
export class ZipDialogComponent implements OnInit, AfterContentInit {

  private folderValidationMessages = {
    required: 'Zip name is required',
    slashesForbidden: 'Slashes are forbidden in zip name.',
    dotsForbidden: 'Dots are forbidden in zip name.',
    maxLengthForbidden: 'Maximum allowed name length is 255 characters.',
  };

  private props: {
    path: string,
    state: string,
    files: File[],
  };

  public validationResult: FS3ValidationResult;

  public componentForm: FormGroup = new FormGroup({});
  public zipName: FormControl = new FormControl('', [this.nameValidator()]);

  private isDblClick = false;
  private goingToSubmit = false;

  private nameValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const str = control.value.replace(/ /g, '');
      if (this.goingToSubmit && !str) { // no error on empty input when user are not submitting
        return {required: this.folderValidationMessages.required}
      }

      if (control.value.length > 255) {
        return {maxLengthForbidden: this.folderValidationMessages.maxLengthForbidden}
      }

      if (str.match(/\//)) {
        return {slashesForbidden: this.folderValidationMessages.slashesForbidden}
      }
      if (str === '.' || str === '..') {
        return {dotsForbidden: this.folderValidationMessages.dotsForbidden}
      }

      return null;
    };
  }

  constructor(public dialogRef: MatDialogRef<ZipDialogComponent>,
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.props = data;
  }
  ngOnInit() {
    let zippedName = getDownloadZipName(this.props.files);
    zippedName = zippedName.match(/.*\.zip$/i) ? zippedName :  zippedName + '.zip'
    this.zipName.setValue(zippedName);
    this.componentForm.addControl('zipName', this.zipName);
  }

  ngAfterContentInit() {
    document.getElementById('zip-name-input').focus()
  }

  public handleKeyDown(event: Event) {
    event.stopPropagation();
    this.goingToSubmit = false;
    this.zipName.updateValueAndValidity();
    this.validationResult = null;
  }
  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }
    if (this.isDblClick) {
      return false;
    }

    this.goingToSubmit = true;
    this.zipName.updateValueAndValidity();
    if (!this.zipName.valid) {
      const errorKey = Object.keys(this.zipName.errors)[0]; // get error key from input errors
      this.validationResult = {
        isValid: false,
        message: this.zipName.errors[errorKey] // get error string by errorKey
      };
      return false;
    }

    this.isDblClick = true;

    const zipNameValue = this.zipName.value.trim();
    const zippedName = zipNameValue.match(/.*\.zip$/i) ? zipNameValue :  zipNameValue + '.zip'

    this.apiService
      .zipFiles(
        `${this.props.path}/${zippedName}`,
        this.props.files,
      )
      .subscribe(
        data => {
          const resultFile = this.makeInstantFile(this.props.path, zippedName, 'f');
          resultFile.animateAndFocus = true;
          resultFile.isPending = true;
          resultFile.jobID = data['job_id'];
          this.dialogRef.close({
            isSuccess: true, resultFile: resultFile
          });
        },
        error => {
          const { exception } = error;
          if (exception && exception.status === 400 && exception.error && exception.error.message) {
            this.validationResult = {
              isValid: false,
              message: exception.error.message
            }
            this.isDblClick = false;
          } else {
            this.dialogRef.close({ isSuccess: false, error });
          }
        }
      );
  }

  public makeInstantFile(path, name, type): File {
    // const name = name;
    // const type = type;
    const owner = '';
    const perm = 0;
    const time = (new Date()).getTime();
    const size = 0;
    const file = File.genFile({ name, type, owner, perm, time, size, path });
    // file.isPending = true;
    return file
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

}
